import { cloneNode } from '@finsweet/ts-utils';

import { SELECTORS } from '$utils/constants';
import type { Profile, ProfileList } from '$utils/types';

import { formatNumber } from './formatNumber';

export const populateProfiles = (allProfiles: Profile[]) => {
  // Clone and query all selectors

  const creatorTemplate = document.querySelector(SELECTORS.creatorItem) as HTMLElement;
  const creatorList = document.querySelector(SELECTORS.creatorList) as HTMLElement;

  creatorList.innerHTML = '';
  // Loop through all profiles and append them to the list
  allProfiles.forEach((profile: Profile) => {
    const creatorItem = cloneNode(creatorTemplate);
    const creatorImage = creatorItem.querySelector(SELECTORS.creatorImage) as HTMLImageElement;
    const creatorUsername = creatorItem.querySelector(SELECTORS.creatorUsername) as HTMLElement;
    const creatorName = creatorItem.querySelector(SELECTORS.creatorName) as HTMLElement;
    const creatorFollowers = creatorItem.querySelector(SELECTORS.creatorFollowers) as HTMLElement;
    const creatorLikes = creatorItem.querySelector(SELECTORS.creatorLikes) as HTMLElement;
    const creatorEngagement = creatorItem.querySelector(SELECTORS.creatorEngagement) as HTMLElement;
    const creatorLocationPercentage = creatorItem.querySelector(
      SELECTORS.creatorLocationPercentage
    ) as HTMLElement;
    const creatorVerified = creatorItem.querySelector(SELECTORS.isVerified) as HTMLElement;
    // return if any of these elements don't exist

    // setting values for each element
    if (!profile.is_verified) {
      creatorVerified.remove();
    }
    creatorImage.src = profile.image_url ?? '';
    creatorUsername.innerText = profile.platform_username ?? '';
    creatorName.innerText = profile.full_name ?? '';

    if (profile.follower_count) {
      creatorFollowers.innerText = formatNumber(profile.follower_count ?? 0);
    } else {
      creatorFollowers.innerText = formatNumber(profile.subscriber_count ?? 0);
    }
    creatorLikes.innerText = formatNumber(profile.average_likes ?? 0) ?? '';

    if (profile.engagement_rate) {
      creatorEngagement.innerText = `${profile.engagement_rate.toString().slice(0, 4)}%`;
    }

    creatorLocationPercentage.innerText = profile?.filter_match?.audience_locations
      ? `${Math.round(profile?.filter_match?.audience_locations?.[0]?.percentage_value)}%`
      : '-';

    creatorList.appendChild(creatorItem);
  });
};
